export const mapSellerProductToDurationInMonths = ({
    sellerProduct
}: {
    sellerProduct: string;
}) => {
    switch (sellerProduct) {
        case 'THREE_MONTHS':
            return 3;
        case 'TWELVE_MONTHS':
            return 12;
        default:
            return null;
    }
};
